import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AxiosError, AxiosResponse, AxiosResponseHeaders } from "axios";
import { Thunk } from "../../store";
import {
  BackendListaTareasAbiertasPorUsuarioCaso,
  getCurrentDomain,
} from "../../../apis/backend/Api";
import mock_Json from "../../../dataJson/ObtenerTareasAbiertasUsuarioCaso.json";
import {
  formatearMensajeBackend,
  ordenarTareas,
  procesarDosPropiedadMapeo,
  procesarPrioridades,
} from "../../../apis/helper/helperApi";
import { formatearFechaCustom } from "../../../components/common/helper/formatoFecha";
import { TypeStatus } from "../../helpers/constantes";

interface State {
  listaTareasAbiertasPorUsuarioCaso: any[];
  status: TypeStatus;
  isLoading: boolean;
  Success: boolean;
  Mensaje: string | null;
  error: string | null;
}

const initialState: State = {
  listaTareasAbiertasPorUsuarioCaso: [],
  status: "idle",
  isLoading: false,
  Success: false,
  Mensaje: "",
  error: null,
};
interface defaultResponse {
  data: any;
  status: number;
  statusText: string;
  headers: AxiosResponseHeaders | {};
  config: any;
  request?: any;
}
const defaultResp: defaultResponse = {
  data: undefined,
  status: 0,
  statusText: "",
  headers: {},
  config: undefined,
};
const listaTareasAbiertasPorUsuarioCasoSlice = createSlice({
  name: "listaTareasAbiertasPorUsuarioCaso",
  initialState,
  reducers: {
    setListaTareasAbiertasPorUsuarioCaso: (
      state,
      action: PayloadAction<any[]>,
    ) => {
      state.listaTareasAbiertasPorUsuarioCaso = action.payload;
    },
    getListaTareasAbiertasPorUsuarioCaso: (
      state,
      action: PayloadAction<any[]>,
    ) => {
      state.listaTareasAbiertasPorUsuarioCaso = action.payload;
    },
    setClearListaTareasAbiertasPorUsuarioCaso: (
      state,
      action: PayloadAction<any[]>,
    ) => {
      state = initialState;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setStatus: (state, action: PayloadAction<TypeStatus>) => {
      state.status = action.payload;
    },
    setResult: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setSuccess: (state, action: PayloadAction<boolean>) => {
      state.Success = action.payload;
    },
    setMensaje: (state, action: PayloadAction<string>) => {
      state.Mensaje = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
  },
});
export const setBackendListaTareasAbiertasPorUsuarioCaso =
  (Usuario: string, Caso: number): Thunk =>
  async (dispatch): Promise<AxiosResponse | AxiosError> => {
    dispatch(setIsLoading(true));

    try {
      const response: AxiosResponse =
        await BackendListaTareasAbiertasPorUsuarioCaso(Usuario, Caso);

      const isError =
        response.data?.Success === false ||
        (response.data?.ResultadoSolicitud !== undefined &&
          response.data?.ResultadoSolicitud !== 200);

      if (isError) {
        dispatch(setIsLoading(false));
        dispatch(setStatus("failed"));
        dispatch(setSuccess(false));
      } else {
        let dataordenar = response.data.Data || [];
        let ordenarLista = [...dataordenar];

        ordenarLista.sort(ordenarTareas);
        ordenarLista = procesarPrioridades(ordenarLista);
        ordenarLista = procesarDosPropiedadMapeo(
          ordenarLista,
          "last_update_date",
          "UltimaActualizacion",
        );
        ordenarLista = procesarDosPropiedadMapeo(ordenarLista, "id", "Tarea");
        ordenarLista = procesarDosPropiedadMapeo(
          ordenarLista,
          "FechaHoraInicio",
          "FechaAlta",
        );
        ordenarLista = ordenarLista.map((e: any) => ({
          ...e,
          FechaHoraInicio: formatearFechaCustom(e.FechaHoraInicio),
          UltimaActualizacion: formatearFechaCustom(e.UltimaActualizacion),
          FechaAlta: formatearFechaCustom(e.FechaAlta),
          assigned_date: formatearFechaCustom(e.assigned_date),
          dueDate: formatearFechaCustom(e.dueDate),
          archivedDate: formatearFechaCustom(e.archivedDate),
          reached_state_date: formatearFechaCustom(e.reached_state_date),
          last_update_date: formatearFechaCustom(e.last_update_date),
        }));

        dispatch(setListaTareasAbiertasPorUsuarioCaso(ordenarLista));
        dispatch(setIsLoading(false));
        dispatch(setStatus("succeeded"));
        dispatch(setSuccess(true));
      }
      dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));

      return response.data;
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(setSuccess(false));
      dispatch(setStatus("failed"));

      if (error.response?.status === 401) {
        dispatch(setStatus("noAutorice"));
        dispatch(
          setMensaje(
            formatearMensajeBackend(
              "Tu sesión ha expirado. Vuelve a iniciar sesión",
            ),
          ),
        );
      } else if (error.response) {
        // Hay respuesta del servidor, pero es otro error (400, 422, 500, etc.)
        console.error(
          "Error de servidor:",
          error.response.status,
          error.response.data,
        );

        const errorData = error.response.data;
        const mensajeBackend = errorData?.Mensaje;
        const resultadoSolicitud = errorData?.ResultadoSolicitud;

        if (
          mensajeBackend &&
          (resultadoSolicitud !== 200 || errorData?.Success === false)
        ) {
          dispatch(setMensaje(formatearMensajeBackend(mensajeBackend)));
        } else {
          dispatch(
            setMensaje(
              `Error ${error.response.status}: Ocurrió un problema en el servidor.`,
            ),
          );
        }
      } else if (error.request) {
        console.error("Error de conexión:", error.message);
        dispatch(
          setMensaje(
            "No se pudo conectar al servidor. Por favor, revisa tu conexión a internet o tu VPN.",
          ),
        );
      } else {
        console.error("Error de red o solicitud:", error.message);
        dispatch(
          setMensaje(
            "Ocurrió un problema con la red. Por favor, verifica tu conexión.",
          ),
        );
      }
      return error as AxiosError;
    } finally {
      dispatch(setIsLoading(false));
      if (getCurrentDomain() === "localhost") {
        dispatch(setIsLoading(true));
        let response: AxiosResponse = defaultResp;
        response.data = mock_Json;

        const mockData: any = mock_Json;
        const isErrorMock =
          mockData?.Success === false ||
          (mockData?.ResultadoSolicitud !== undefined &&
            mockData?.ResultadoSolicitud !== 200);

        if (isErrorMock) {
          dispatch(setIsLoading(false));
          dispatch(setStatus("failed"));
          dispatch(setSuccess(false));
        } else {
          let dataordenar = mock_Json.Data || [];
          let ordenarLista = [...dataordenar];
          ordenarLista.sort(ordenarTareas);
          ordenarLista = procesarPrioridades(ordenarLista);
          ordenarLista = procesarDosPropiedadMapeo(
            ordenarLista,
            "last_update_date",
            "UltimaActualizacion",
          );
          ordenarLista = procesarDosPropiedadMapeo(ordenarLista, "id", "Tarea");
          ordenarLista = procesarDosPropiedadMapeo(
            ordenarLista,
            "FechaHoraInicio",
            "FechaAlta",
          );
          ordenarLista = ordenarLista.map((e: any) => ({
            ...e,
            FechaHoraInicio: formatearFechaCustom(e.FechaHoraInicio),
            UltimaActualizacion: formatearFechaCustom(e.UltimaActualizacion),
            FechaAlta: formatearFechaCustom(e.FechaAlta),
            assigned_date: formatearFechaCustom(e.assigned_date),
            dueDate: formatearFechaCustom(e.dueDate),
            archivedDate: formatearFechaCustom(e.archivedDate),
            reached_state_date: formatearFechaCustom(e.reached_state_date),
            last_update_date: formatearFechaCustom(e.last_update_date),
          }));

          dispatch(setListaTareasAbiertasPorUsuarioCaso(ordenarLista));
          dispatch(setIsLoading(false));
          dispatch(setStatus("succeeded"));
          dispatch(setSuccess(true));
        }
        dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));
        const mock401 = await import("../../../dataJson/401.json");
        if (mock401.status === 401) {
          dispatch(setStatus("noAutorice"));
          dispatch(
            setMensaje(
              formatearMensajeBackend(
                "Tu sesión ha expirado. Vuelve a iniciar sesión",
              ),
            ),
          );
        }
      }
    }
  };

export const setBackendClearListaTareasAbiertasPorUsuarioCaso =
  (): Thunk =>
  async (dispatch): Promise<AxiosResponse | AxiosError> => {
    dispatch(setIsLoading(true));
    try {
      let response: AxiosResponse = defaultResp;
      dispatch(setListaTareasAbiertasPorUsuarioCaso([]));
      dispatch(setIsLoading(false));
      dispatch(setStatus("idle"));
      dispatch(setSuccess(false));
      dispatch(setMensaje(""));
      return response.data;
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(setStatus("failed"));
      return error as AxiosError;
    } finally {
      dispatch(setIsLoading(false));
    }
  };

export const {
  setListaTareasAbiertasPorUsuarioCaso,
  getListaTareasAbiertasPorUsuarioCaso,
  setClearListaTareasAbiertasPorUsuarioCaso,
  setIsLoading,
  setStatus,
  setResult,
  setSuccess,
  setMensaje,
  setError,
} = listaTareasAbiertasPorUsuarioCasoSlice.actions;

export default listaTareasAbiertasPorUsuarioCasoSlice.reducer;
